import { render, staticRenderFns } from "./PromotionEditView.vue?vue&type=template&id=1c73aa78"
import script from "./PromotionEditView.vue?vue&type=script&lang=ts"
export * from "./PromotionEditView.vue?vue&type=script&lang=ts"
import style0 from "./PromotionEditView.vue?vue&type=style&index=0&id=1c73aa78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports